var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 d-flex align-items-start mb-3"},[_c('eg-b-button',{staticClass:"btn go-back-link p-0 d-flex p-0",attrs:{"to":_vm.to}},[_c('eg-b-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }